import { takeLatest, put, call } from 'redux-saga/effects';
import { apiRequest } from '../../apiRequest';
import { URLs } from '../../urls';

import { GetAssessmentActionsTypes, IGetAssessmentResult, GetAssessmentRequestSucces, GetAssessmentRequestError,
	GetAssessmentsActionsTypes, IGetAssessmentsResult, GetAssessmentsRequestSucces, GetAssessmentsRequestError,
	CreateAssessmentActionsTypes, ICreateAssessmentResult, CreateAssessmentRequestSucces, CreateAssessmentRequestError,
	UpdateAssessmentActionsTypes, IUpdateAssessmentResult, UpdateAssessmentRequestSucces, UpdateAssessmentRequestError,
	DeleteAssessmentActionsTypes, IDeleteAssessmentResult, DeleteAssessmentRequestSucces, DeleteAssessmentRequestError,
} from './types';

function* sendGetAssessmentRequest(action: any) {
	console.log('='.repeat(80));
	console.log('[GET ASSESSMENT SAGA] 📥 Request started');
	console.log('[GET ASSESSMENT] Action:', action);
	console.log('[GET ASSESSMENT] Assessment ID:', action.id);
	console.log('[GET ASSESSMENT] Endpoint:', `${URLs.GET_ASSESSMENT_ENDPOINT}/${action.id}`);
	
	try {
		// API call
		const response : IGetAssessmentResult = yield call(apiRequest, {
			endpoint: URLs.GET_ASSESSMENT_ENDPOINT + "/" + action.id,
			method: 'GET',
		});

	console.log('[GET ASSESSMENT] 📤 Response received:', response);
	console.log('[GET ASSESSMENT] Success:', response.success);
	console.log('[GET ASSESSMENT] Assessment data:', response.data);
	if ((response as any).data) {
		const data = (response as any).data;
		console.log('[GET ASSESSMENT] - ID:', data.id);
		console.log('[GET ASSESSMENT] - Name:', data.name || data.examName);
		console.log('[GET ASSESSMENT] - Status:', data.status);
		console.log('[GET ASSESSMENT] - Questions:', data.questions);
		console.log('[GET ASSESSMENT] - Duration:', data.duration);
		console.log('[GET ASSESSMENT] - Date:', data.scheduledDate);
		console.log('[GET ASSESSMENT] - Class IDs:', data.classIds);
		console.log('[GET ASSESSMENT] - OMR Sheet ID:', data.omrSheetId);
		console.log('[GET ASSESSMENT] - Grading Scale ID:', data.gradingScaleId);
	}

		if (response.success == true) {
			let putData: GetAssessmentRequestSucces = {
				type: GetAssessmentActionsTypes.GET_ASSESSMENT_SUCCESS,
				data: response,
				loading: false,
			};
			console.log('[GET ASSESSMENT] ✅ Dispatching SUCCESS action:', putData.type);
			yield put<GetAssessmentRequestSucces>(putData);
		}

		if (response.success == false) {
			let putData: GetAssessmentRequestError = {
				type: GetAssessmentActionsTypes.GET_ASSESSMENT_ERROR,
				error: response.error.toString(),
				loading: false
			};
			console.log('[GET ASSESSMENT] ❌ Dispatching ERROR action:', putData.type);
			console.log('[GET ASSESSMENT] Error:', putData.error);
			yield put<GetAssessmentRequestError>(putData);
		}

	} catch (e: any) {
		console.log('[GET ASSESSMENT] 💥 Exception caught:', e);
		console.log('[GET ASSESSMENT] Error message:', e?.message);
		console.log('[GET ASSESSMENT] Error stack:', e?.stack);
		
		let putData: GetAssessmentRequestError = {
			type: GetAssessmentActionsTypes.GET_ASSESSMENT_ERROR,
			error: e?.message || e?.toString() || 'Unknown error',
			loading: false
		};
		console.log('[GET ASSESSMENT] ❌ Dispatching ERROR action (exception)');
		yield put<GetAssessmentRequestError>(putData);
	}
	console.log('[GET ASSESSMENT SAGA] 🏁 Request completed');
	console.log('='.repeat(80));
}

function* sendGetAssessmentsRequest(action: any) {
	const userId = localStorage.getItem("UserId");
	
	console.log('='.repeat(80));
	console.log('[GET ASSESSMENTS SAGA] 📥 Request started');
	console.log('[GET ASSESSMENTS] Action:', action);
	console.log('[GET ASSESSMENTS] User ID:', userId);
	console.log('[GET ASSESSMENTS] Endpoint:', `${URLs.GET_ASSESSMENTS_ENDPOINT}?userId=${userId}`);
	
	try {
		// API call
		const response : IGetAssessmentsResult = yield call(apiRequest, {
			endpoint: URLs.GET_ASSESSMENTS_ENDPOINT + "?userId=" + userId,
			method: 'GET',
		});
		
	console.log('[GET ASSESSMENTS] 📤 Response received:', response);
	console.log('[GET ASSESSMENTS] Success:', response.success);
	console.log('[GET ASSESSMENTS] Assessments data:', response?.data?.assessments);
	console.log('[GET ASSESSMENTS] Total assessments:', response?.data?.assessments?.length || 0);
	
	const assessments: any = response?.data?.assessments;
	if (assessments && assessments.length > 0) {
		console.log('[GET ASSESSMENTS] First assessment sample:');
		const first: any = assessments[0];
		console.log('[GET ASSESSMENTS] - ID:', first?.id);
		console.log('[GET ASSESSMENTS] - Name:', first?.name || first?.examName);
		console.log('[GET ASSESSMENTS] - Status:', first?.status);
		console.log('[GET ASSESSMENTS] - Type:', first?.type);
		console.log('[GET ASSESSMENTS] - OMR Sheet ID:', first?.omrSheetId);
		console.log('[GET ASSESSMENTS] - OMR Sheet IDs (array):', first?.omrSheetIds);
		console.log('[GET ASSESSMENTS] - Grading Scale ID:', first?.gradingScaleId);
		console.log('[GET ASSESSMENTS] - Grading Scale IDs (array):', first?.gradingScaleIds);
	}

		if (response.success == true) {
			let putData: GetAssessmentsRequestSucces = {
				type: GetAssessmentsActionsTypes.GET_ASSESSMENTS_SUCCESS,
				data: response,
				loading: false,
			};
			console.log('[GET ASSESSMENTS] ✅ Dispatching SUCCESS action:', putData.type);
			console.log('[GET ASSESSMENTS] Dispatched data:', putData.data);
			yield put<GetAssessmentsRequestSucces>(putData);
		}

		if (response.success == false) {
			let putData: GetAssessmentsRequestError = {
				type: GetAssessmentsActionsTypes.GET_ASSESSMENTS_ERROR,
				error: response.error.toString(),
				loading: false
			};
			console.log('[GET ASSESSMENTS] ❌ Dispatching ERROR action:', putData.type);
			console.log('[GET ASSESSMENTS] Error:', putData.error);
			yield put<GetAssessmentsRequestError>(putData);
		}

	} catch (e: any) {
		console.log('[GET ASSESSMENTS] 💥 Exception caught:', e);
		console.log('[GET ASSESSMENTS] Error message:', e?.message);
		console.log('[GET ASSESSMENTS] Error stack:', e?.stack);
		
		let putData: GetAssessmentsRequestError = {
			type: GetAssessmentsActionsTypes.GET_ASSESSMENTS_ERROR,
			error: e?.message || e?.toString() || 'Unknown error',
			loading: false
		};
		console.log('[GET ASSESSMENTS] ❌ Dispatching ERROR action (exception)');
		yield put<GetAssessmentsRequestError>(putData);
	}
	console.log('[GET ASSESSMENTS SAGA] 🏁 Request completed');
	console.log('='.repeat(80));
}

function* sendCreateAssessmentRequest(action: any) {
	const userId = localStorage.getItem("UserId");
	
	console.log('='.repeat(80));
	console.log('[CREATE ASSESSMENT SAGA] 📥 Request started');
	console.log('[CREATE ASSESSMENT] Action:', action);
	console.log('[CREATE ASSESSMENT] User ID:', userId);
	console.log('[CREATE ASSESSMENT] Model:', action.model);
	console.log('[CREATE ASSESSMENT] Model details:');
	console.log('[CREATE ASSESSMENT] - Name:', action.model?.name);
	console.log('[CREATE ASSESSMENT] - Type:', action.model?.type);
	console.log('[CREATE ASSESSMENT] - Status:', action.model?.status);
	console.log('[CREATE ASSESSMENT] - Class IDs:', action.model?.classIds);
	console.log('[CREATE ASSESSMENT] - OMR Sheet ID:', action.model?.omrSheetId);
	console.log('[CREATE ASSESSMENT] - Grading Scale ID:', action.model?.gradingScaleId);
	console.log('[CREATE ASSESSMENT] - Duration:', action.model?.duration);
	console.log('[CREATE ASSESSMENT] - Date:', action.model?.scheduledDate);
	console.log('[CREATE ASSESSMENT] Endpoint:', `${URLs.CREATE_ASSESSMENT_ENDPOINT}?userId=${userId}`);
	
	try {
		const response : ICreateAssessmentResult = yield call(apiRequest, {
			endpoint: URLs.CREATE_ASSESSMENT_ENDPOINT + "?userId=" + userId,
			method: 'POST',
			body: action.model
		});

	console.log('[CREATE ASSESSMENT] 📤 Response received:', response);
	console.log('[CREATE ASSESSMENT] Success:', response.success);
	const createdData = (response as any).data;
	console.log('[CREATE ASSESSMENT] Created assessment:', createdData);
	if (createdData) {
		console.log('[CREATE ASSESSMENT] - New ID:', createdData.id);
		console.log('[CREATE ASSESSMENT] - Name:', createdData.name);
		console.log('[CREATE ASSESSMENT] - OMR Sheet ID:', createdData.omrSheetId);
		console.log('[CREATE ASSESSMENT] - Grading Scale ID:', createdData.gradingScaleId);
	}

		if (response.success == true) {
			let putData: CreateAssessmentRequestSucces = {
				type: CreateAssessmentActionsTypes.POST_CREATE_ASSESSMENT_SUCCESS,
				data: response,
				loading: false,
				success: response.success
			};
			console.log('[CREATE ASSESSMENT] ✅ Dispatching SUCCESS action:', putData.type);
			yield put<CreateAssessmentRequestSucces>(putData);
		}

		if (response.success == false) {
			let putData: CreateAssessmentRequestError = {
				type: CreateAssessmentActionsTypes.POST_CREATE_ASSESSMENT_ERROR,
				error: response.error.toString(),
				loading: false
			};
			console.log('[CREATE ASSESSMENT] ❌ Dispatching ERROR action:', putData.type);
			console.log('[CREATE ASSESSMENT] Error:', putData.error);
			yield put<CreateAssessmentRequestError>(putData);
		}

	} catch (e: any) {
		console.log('[CREATE ASSESSMENT] 💥 Exception caught:', e);
		console.log('[CREATE ASSESSMENT] Error message:', e?.message);
		console.log('[CREATE ASSESSMENT] Error stack:', e?.stack);
		
		let putData: CreateAssessmentRequestError = {
			type: CreateAssessmentActionsTypes.POST_CREATE_ASSESSMENT_ERROR,
			error: e?.message || e?.toString() || 'Unknown error',
			loading: false
		};
		console.log('[CREATE ASSESSMENT] ❌ Dispatching ERROR action (exception)');
		yield put<CreateAssessmentRequestError>(putData);
	}
	console.log('[CREATE ASSESSMENT SAGA] 🏁 Request completed');
	console.log('='.repeat(80));
}

function* sendUpdateAssessmentRequest(action: any) {
	console.log('='.repeat(80));
	console.log('[UPDATE ASSESSMENT SAGA] 📥 Request started');
	console.log('[UPDATE ASSESSMENT] Action:', action);
	console.log('[UPDATE ASSESSMENT] Assessment ID:', action.id);
	console.log('[UPDATE ASSESSMENT] Model:', action.model);
	console.log('[UPDATE ASSESSMENT] Model details:');
	console.log('[UPDATE ASSESSMENT] - Status:', action.model?.status);
	console.log('[UPDATE ASSESSMENT] - Name:', action.model?.name);
	console.log('[UPDATE ASSESSMENT] - Type:', action.model?.type);
	console.log('[UPDATE ASSESSMENT] - Duration:', action.model?.duration);
	console.log('[UPDATE ASSESSMENT] - Date:', action.model?.scheduledDate);
	console.log('[UPDATE ASSESSMENT] - Class IDs:', action.model?.classIds);
	console.log('[UPDATE ASSESSMENT] - OMR Sheet ID:', action.model?.omrSheetId);
	console.log('[UPDATE ASSESSMENT] - Grading Scale ID:', action.model?.gradingScaleId);
	console.log('[UPDATE ASSESSMENT] Endpoint:', `${URLs.UPDATE_ASSESSMENT_ENDPOINT}/${action.id}`);
	
	try {
		const response : IUpdateAssessmentResult = yield call(apiRequest, {
			endpoint: URLs.UPDATE_ASSESSMENT_ENDPOINT + "/" + action.id,
			method: 'PUT',
			body: action.model
		});

	console.log('[UPDATE ASSESSMENT] 📤 Response received:', response);
	console.log('[UPDATE ASSESSMENT] Success:', response.success);
	const updatedData = (response as any).data;
	console.log('[UPDATE ASSESSMENT] Updated assessment:', updatedData);
	if (updatedData) {
		console.log('[UPDATE ASSESSMENT] - ID:', updatedData.id);
		console.log('[UPDATE ASSESSMENT] - Status:', updatedData.status);
		console.log('[UPDATE ASSESSMENT] - OMR Sheet ID:', updatedData.omrSheetId);
		console.log('[UPDATE ASSESSMENT] - Grading Scale ID:', updatedData.gradingScaleId);
		console.log('[UPDATE ASSESSMENT] - Updated at:', updatedData.updatedAt);
	}

		if (response.success == true) {
			let putData: UpdateAssessmentRequestSucces = {
				type: UpdateAssessmentActionsTypes.PUT_UPDATE_ASSESSMENT_SUCCESS,
				data: response,
				loading: false,
			};
			console.log('[UPDATE ASSESSMENT] ✅ Dispatching SUCCESS action:', putData.type);
			yield put<UpdateAssessmentRequestSucces>(putData);
		}

		if (response.success == false) {
			let putData: UpdateAssessmentRequestError = {
				type: UpdateAssessmentActionsTypes.PUT_UPDATE_ASSESSMENT_ERROR,
				error: response.error.toString(),
				loading: false
			};
			console.log('[UPDATE ASSESSMENT] ❌ Dispatching ERROR action:', putData.type);
			console.log('[UPDATE ASSESSMENT] Error:', putData.error);
			yield put<UpdateAssessmentRequestError>(putData);
		}

	} catch (e: any) {
		console.log('[UPDATE ASSESSMENT] 💥 Exception caught:', e);
		console.log('[UPDATE ASSESSMENT] Error message:', e?.message);
		console.log('[UPDATE ASSESSMENT] Error stack:', e?.stack);
		
		let putData: UpdateAssessmentRequestError = {
			type: UpdateAssessmentActionsTypes.PUT_UPDATE_ASSESSMENT_ERROR,
			error: e?.message || e?.toString() || 'Unknown error',
			loading: false
		};
		console.log('[UPDATE ASSESSMENT] ❌ Dispatching ERROR action (exception)');
		yield put<UpdateAssessmentRequestError>(putData);
	}
	console.log('[UPDATE ASSESSMENT SAGA] 🏁 Request completed');
	console.log('='.repeat(80));
}

function* sendDeleteAssessmentRequest(action: any) {
	console.log('='.repeat(80));
	console.log('[DELETE ASSESSMENT SAGA] 📥 Request started');
	console.log('[DELETE ASSESSMENT] Action:', action);
	console.log('[DELETE ASSESSMENT] Assessment ID:', action.id);
	console.log('[DELETE ASSESSMENT] Endpoint:', `${URLs.DELETE_ASSESSMENT_ENDPOINT}/${action.id}`);
	
	try {
		const response : IDeleteAssessmentResult = yield call(apiRequest, {
			endpoint: URLs.DELETE_ASSESSMENT_ENDPOINT + "/" + action.id,
			method: 'DELETE',
		});

	console.log('[DELETE ASSESSMENT] 📤 Response received:', response);
	console.log('[DELETE ASSESSMENT] Success:', response.success);
	console.log('[DELETE ASSESSMENT] Data:', (response as any).data);

		if (response.success == true) {
			let putData: DeleteAssessmentRequestSucces = {
				type: DeleteAssessmentActionsTypes.DELETE_ASSESSMENT_SUCCESS,
				data: response,
				loading: false,
			};
			console.log('[DELETE ASSESSMENT] ✅ Dispatching SUCCESS action:', putData.type);
			console.log('[DELETE ASSESSMENT] Deleted ID:', action.id);
			yield put<DeleteAssessmentRequestSucces>(putData);
		}

		if (response.success == false) {
			let putData: DeleteAssessmentRequestError = {
				type: DeleteAssessmentActionsTypes.DELETE_ASSESSMENT_ERROR,
				error: response.error.toString(),
				loading: false
			};
			console.log('[DELETE ASSESSMENT] ❌ Dispatching ERROR action:', putData.type);
			console.log('[DELETE ASSESSMENT] Error:', putData.error);
			yield put<DeleteAssessmentRequestError>(putData);
		}

	} catch (e: any) {
		console.log('[DELETE ASSESSMENT] 💥 Exception caught:', e);
		console.log('[DELETE ASSESSMENT] Error message:', e?.message);
		console.log('[DELETE ASSESSMENT] Error stack:', e?.stack);
		
		let putData: DeleteAssessmentRequestError = {
			type: DeleteAssessmentActionsTypes.DELETE_ASSESSMENT_ERROR,
			error: e?.message || e?.toString() || 'Unknown error',
			loading: false
		};
		console.log('[DELETE ASSESSMENT] ❌ Dispatching ERROR action (exception)');
		yield put<DeleteAssessmentRequestError>(putData);
	}
	console.log('[DELETE ASSESSMENT SAGA] 🏁 Request completed');
	console.log('='.repeat(80));
}

export function* handler() {
	yield takeLatest(GetAssessmentActionsTypes.GET_ASSESSMENT, sendGetAssessmentRequest);
	yield takeLatest(GetAssessmentsActionsTypes.GET_ASSESSMENTS, sendGetAssessmentsRequest);
	yield takeLatest(CreateAssessmentActionsTypes.POST_CREATE_ASSESSMENT, sendCreateAssessmentRequest);
	yield takeLatest(UpdateAssessmentActionsTypes.PUT_UPDATE_ASSESSMENT, sendUpdateAssessmentRequest);
	yield takeLatest(DeleteAssessmentActionsTypes.DELETE_ASSESSMENT, sendDeleteAssessmentRequest);
}

